"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.animations = void 0;
var _fadeIn = _interopRequireDefault(require("./fadeIn"));
var _fadeOut = _interopRequireDefault(require("./fadeOut"));
var _scaleUp = _interopRequireDefault(require("./scaleUp"));
var _scaleDown = _interopRequireDefault(require("./scaleDown"));
var _slideFromBottom = _interopRequireDefault(require("./slideFromBottom"));
var _slideFromLeft = _interopRequireDefault(require("./slideFromLeft"));
var _slideFromRight = _interopRequireDefault(require("./slideFromRight"));
var _slideFromTop = _interopRequireDefault(require("./slideFromTop"));
var _slideToBottom = _interopRequireDefault(require("./slideToBottom"));
var _slideToLeft = _interopRequireDefault(require("./slideToLeft"));
var _slideToRight = _interopRequireDefault(require("./slideToRight"));
var _slideToTop = _interopRequireDefault(require("./slideToTop"));
var _none = _interopRequireDefault(require("./none"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var animations = {
  fadeIn: _fadeIn["default"],
  fadeOut: _fadeOut["default"],
  scaleUp: _scaleUp["default"],
  scaleDown: _scaleDown["default"],
  slideFromBottom: _slideFromBottom["default"],
  slideFromLeft: _slideFromLeft["default"],
  slideFromRight: _slideFromRight["default"],
  slideFromTop: _slideFromTop["default"],
  slideToBottom: _slideToBottom["default"],
  slideToLeft: _slideToLeft["default"],
  slideToRight: _slideToRight["default"],
  slideToTop: _slideToTop["default"],
  none: _none["default"]
};
exports.animations = animations;